/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Audio_Description_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Audio Description Event {eventIndex}" |
*
* @param {Event_Audio_Description_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_audio_description_aria_label = /** @type {((inputs: Event_Audio_Description_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Audio_Description_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement de description audio ${i?.eventIndex}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audiobeschreibungsereignis ${i?.eventIndex}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Descrizione audio Evento ${i?.eventIndex}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие аудиоописания ${i?.eventIndex}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento de descripción de audio ${i?.eventIndex}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频描述事件${i?.eventIndex}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオ解説イベント ${i?.eventIndex}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो विवरण इवेंट ${i?.eventIndex}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento de audiodescrição ${i?.eventIndex}`)
	return /** @type {LocalizedString} */ (`Audio Description Event ${i?.eventIndex}`)
});